import React, { useEffect, useState } from 'react';

import Dialog from 'components/Dialog';
import { closeAddWarrant } from 'reducers/DialogsReducer';
import { connect } from 'react-redux';
import WarrantTab from './WarrantTab';

function AddWarrantDialog(props) {
  const [isCloseClick, setIsCloseClick] = useState(false);
  const close = () => {
    setIsCloseClick(true);
  };
  return (
    <Dialog toolbar fullScreen onClose={close} title="Add Warrant">
      <WarrantTab isCloseClick={isCloseClick} setIsCloseClick={setIsCloseClick} />
    </Dialog>
  );
}

export default connect(null, {
  closeAddWarrant,
})(AddWarrantDialog);
